
export const progressBarStyles = (theme) => ({
  root: {
    marginLeft: '5px',
    marginRight: '5px',
    borderRadius: '20px',
    flexGrow: 1,
  },
});

export const downloadToolbarButtonStyles = (theme) => ({
  sizeSmall: {
    fontSize: '1rem',
  },
});
